import { useTranslation } from 'react-i18next'
import { PhoneNumberOption as UIPhoneNumberOption } from '@jagad/ui'
import type { PhoneNumberOptionProps } from '@jagad/ui'

type ShimProps = Omit<PhoneNumberOptionProps, 'freeLabel'>

export default function PhoneNumberOption(props: ShimProps) {
  const { t } = useTranslation()
  return <UIPhoneNumberOption {...props} freeLabel={t('phoneNumberOption.free')} />
}
